import React from "react";
import { Link } from "react-router-dom";
import { Alert, Container, Table } from "react-bootstrap";
import { getTeam, getTeamSchedule, teamPath, useSchedule } from "./scheduleData";

const TeamSchedule = ({ match }) => {
  const { loading, error, data } = useSchedule();
  const name = match.params.team;

  if (loading) return <Container>Loading schedule...</Container>;
  if (error) {
    return (
      <Container>
        <Alert variant="danger">{error.message}</Alert>
      </Container>
    );
  }
  if (!data.weeks) {
    return (
      <Container>
        <Alert variant="info">The NCBB schedule is currently disabled.</Alert>
      </Container>
    );
  }

  const team = getTeam(data.weeks, name);

  if (!team) {
    return (
      <Container>
        <p>Team not found.</p>
        <Link to="/fumbbl/NCBB/schedule">Back to full schedule</Link>
      </Container>
    );
  }

  const rows = getTeamSchedule(data.weeks, name);

  return (
    <Container>
      <h2>{team.Name}</h2>
      <p className="text-muted">Schedule solution {data.solution}</p>
      <p className="text-muted">
        {team.Conference}
        {team.Rivals.length > 0 && <> &middot; Rival: {team.Rivals.join(", ")}</>}
      </p>
      <Table striped size="sm">
        <thead>
          <tr>
            <th>Week</th>
            <th>Opponent</th>
            <th>Conference</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.week}>
              <td>{r.week}</td>
              {r.bye ? (
                <td colSpan={2}>Bye</td>
              ) : (
                <>
                  <td>
                    <Link to={teamPath(r.opponent.Name)}>
                      {r.opponent.Name}
                    </Link>
                    {team.Rivals.includes(r.opponent.Name) && " (rival)"}
                  </td>
                  <td>{r.opponent.Conference}</td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
      <Link to="/fumbbl/NCBB/schedule">Back to full schedule</Link>
    </Container>
  );
};

export default TeamSchedule;
